export function formatNumber(
  value: number | string,
  options: {
    fractionDigits?: number;
    prefix?: string;
    suffix?: string;
  } = {}
): string {
  const { fractionDigits = 2, prefix = "", suffix = "" } = options;

  if (value === null || value === undefined || value === "") return "0.00";

  const num = Number(value);
  if (isNaN(num)) return String(value);

  return (
    prefix +
    num
      .toLocaleString("en-US", {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      })
      .replace(/\u00A0/g, "") +
    suffix
  );
}
